export default "__VITE_ASSET__yFMSL3Kt__"